export const addDataCy = (testId?: string) => (testId ? { "data-cy": testId } : {});

export const openImageInNewTab = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
